import type { RouteRecordRaw } from 'vue-router'

export const errorRoutes: RouteRecordRaw[] = [
  {
    path: '',
    meta: {
      layout: 'error',
    },
    children: [
      {
        path: '/error/403',
        name: '403error',
        component: () => import('@/pages/errors/403'),
      },
      {
        path: '/:catchAll(.*)',
        name: '404error',
        component: () => import('@/pages/errors/404'),
      },
    ],
  },
]
